import(/* webpackMode: "eager" */ "/app/src/app/error.page.tsx")